( function () {
	'use strict';

	function scrollBodyLock () {
		function link ( scope, elem ) {
			elem.on( 'mousewheel DOMMouseScroll', function ( e ) {
				var scrollTo = 0;

				e.preventDefault();

				if ( e.type === 'mousewheel' ) {
					scrollTo = ( e.originalEvent.wheelDelta * -1 );
				} else {
					// trigger when DOMMouseScroll
					scrollTo = 40 * e.originalEvent.detail;
				}

				elem.scrollTop( scrollTo + elem.scrollTop() );
			} );
		}

		return {
			'restrict' : 'C',
			'link'     : link
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'scrollable', scrollBodyLock );
} )( );
